/**
 * Generates a random state parameter for CSRF protection.
 */
export function generateState(): string {
	const array = new Uint8Array(32);
	crypto.getRandomValues(array);
	return base64UrlEncode(array);
}

/**
 * Base64 URL encoding (without padding).
 */
function base64UrlEncode(buffer: Uint8Array): string {
	const base64 = btoa(String.fromCharCode(...buffer));
	return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// Session storage keys
export const OAUTH_STATE_KEY = "entra_id_oauth_state";
